import React, { useState, useEffect } from 'react';
import { DataTable, Page, Card, Link } from '@shopify/polaris';
import SettingsAddEditModal from '../../settingsAddEditModal';
import { openAddModal } from '../../../../shared/components/settingsFunctions.js';
import Toasts from '../../../../shared/components/toasts/toasts.jsx';
import { useLookupStore } from '../../../../context/useStore.js';
import { useToggle } from '../../../../shared/useToogle.js';

export default function SettingsOverheadPercentagesPage() {
  const [overheadpercentages, setOverheadpercentages] = useLookupStore((state) => [state.overheadpercentages, state.setOverheadpercentages]);
  const [modalOpen, setModalOpen] = useToggle(false);
  const [entryId, setEntryId] = useState('');
  const [isAdd, setIsAdd] = useState(true);
  const [entry, setEntry] = useState({
    Year: { type: 'number', label: 'Year', value: '', required: true },
    OverheadPercentage: { type: 'number', label: 'Overhead Percentage', value: '', required: true, step: '0.1' }
  });
  const [toast, setToast] = useState(false);
  const [errorToast, setErrorToast] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Load overhead percentages when component mounts
  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        await setOverheadpercentages();
      } catch (error) {
        console.error('Error loading overhead percentages:', error);
      } finally {
        setIsLoading(false);
      }
    };
    loadData();
  }, [setOverheadpercentages]);

  const url = '/api/overhead_percentages';
  const title = 'Overhead Percentages';

  const rows = overheadpercentages.map((item) => [
    item.Year,
    `${item.OverheadPercentage}%`,
    <Link
      removeUnderline
      onClick={() => {
        console.log('Edit clicked for item:', item);
        console.log('Item ID:', item.ID);
        setIsAdd(false);
        setEntryId(item.ID);
        setEntry({
          Year: { type: 'number', label: 'Year', value: item.Year, required: true },
          OverheadPercentage: { type: 'number', label: 'Overhead Percentage', value: item.OverheadPercentage, required: true, step: '0.1' }
        });
        setModalOpen(true);
      }}
    >
      Edit
    </Link>
  ]);

  return (
    <Page
      title={title}
      backAction={{ content: 'Settings', url: '/settings' }}
      fullWidth
      primaryAction={{
        content: 'Add overhead percentage',
        onAction: () => openAddModal(setModalOpen, entry, setEntry, setIsAdd, setEntryId)
      }}
    >
      <Card>
        {isLoading ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading overhead percentages...</div>
        ) : overheadpercentages.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center' }}>No overhead percentages found. Add your first one!</div>
        ) : (
          <DataTable increasedTableDensity={true} verticalAlign="middle" columnContentTypes={['numeric', 'numeric', 'text']} headings={['Year', 'Overhead Percentage', 'Actions']} rows={rows} />
        )}
      </Card>

      <SettingsAddEditModal
        modalTitle={isAdd ? 'Add Overhead Percentage' : 'Edit Overhead Percentage'}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        isAdd={isAdd}
        entry={entry}
        setEntry={setEntry}
        entryId={entryId}
        url={url}
        setToast={setToast}
        setErrorToast={setErrorToast}
        setItems={setOverheadpercentages}
      />

      <Toasts toast={toast} setToast={setToast} errorToast={errorToast} setErrorToast={setErrorToast} />
    </Page>
  );
}
